module.exports = __webpack_public_path__ + "static/media/phones.b7f2269c.png";